import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BackButton = () => {  
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="back-button" onClick={() => navigate(-1)}>
      <span className="icon-chevron-left">❮</span>
      <span>{t('back_button')}</span>
    </div>
  );
};

export default BackButton;